import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import StatusBadge from "../../../../common/AdminCommonComponents/StatusBadge/StatusBadge"
import DynamicCardRow from "../../../DynamicCardRow/DynamicCardRow"

const ActivityLog = () => {

  const statsData = [
    { title: "Total Custom Permissions".toUpperCase(), value: 0 },
    { title: "Active Admins".toUpperCase(), value: 0 },
    { title: "Total Roles".toUpperCase(), value: 0 },
    { title: "Total Permissions".toUpperCase(), value: 0 },
  ]

  const tableData = [
    { logID: "01", userID: 2, username: "LoremipsumAa", action: "Added permission", section: "Financial Reports", timestamp: "05/12/2024 04:39 AM", performedBy: 'Super admin: Asad Dawood ' },
    { logID: "01", userID: 2, username: "LoremipsumAa", action: "Added permission", section: "Financial Reports", timestamp: "05/12/2024 04:39 AM", performedBy: 'Super admin: Asad Dawood ' },
    { logID: "01", userID: 2, username: "LoremipsumAa", action: "Added permission", section: "Financial Reports", timestamp: "05/12/2024 04:39 AM", performedBy: 'Super admin: Asad Dawood ' },
    { logID: "01", userID: 2, username: "LoremipsumAa", action: "Added permission", section: "Financial Reports", timestamp: "05/12/2024 04:39 AM", performedBy: 'Super admin: Asad Dawood ' },
    { logID: "01", userID: 2, username: "LoremipsumAa", action: "Added permission", section: "Financial Reports", timestamp: "05/12/2024 04:39 AM", performedBy: 'Super admin: Asad Dawood ' },
  ]

  const columns = [
    { name: "Log ID", selector: (row) => row.logID, grow: 0.5 },
    { name: "User ID", selector: (row) => row.userID, grow: 0.5 },
    { name: "Username", selector: (row) => row.username },
    { name: "Action", selector: (row) => row.action },
    { name: "Section", selector: (row) => row.section },
    { name: "Timestamp", selector: (row) => row.timestamp },
    { name: "Performed By", selector: (row) => row.performedBy },
  ]

  return (
    <>
      <div className="bg-white shadow mt-3 px-4 p-3">
        <div className="fw-semibold fs-5 mb-2">Admins</div>
        <DynamicCardRow cards={statsData} />
      </div>

      <div className="bg-white shadow mt-3 px-4 p-3">
        <div className="fw-semibold fs-5">Activity Log</div>
      </div>

      <DynamicDatatable data={tableData} columns={columns} type="yellow" pagination />
    </>
  )
}

export default ActivityLog
